import { render, staticRenderFns } from "./breeder-details-component.vue?vue&type=template&id=674b7e14&scoped=true&lang=pug"
import script from "./breeder-details-component.js?vue&type=script&lang=js&external"
export * from "./breeder-details-component.js?vue&type=script&lang=js&external"
import style0 from "./breeder-details-component.vue?vue&type=style&index=0&id=674b7e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b7e14",
  null
  
)

export default component.exports